import React from 'react';
import { playerAvatarImgClassName } from '../../../utils/avatarClassNames';

const FixedRosterBanner = ({ scrolledPastBanner, roster }) => {
	if (!scrolledPastBanner || roster.length === 0) return null;

	const { image_url, team_name, league } = roster;
	const league_name = league && league.league_name ? league.league_name : 'N/A';
	const platform = league && league.platform ? league.platform : 'N/A';
	const scoring = league && league.scoring ? league.scoring : 'N/A';

	return (
		<div className="fixed top-0 left-0 right-0 h-28 bg-white dark:bg-dark-card text-gray-900 dark:text-dark-text flex items-center justify-center border border-gray-300 dark:border-dark-border shadow-lg z-50">
			<div className="flex items-center">
				<div
					onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
					style={{ cursor: 'pointer' }}
					className="flex items-center"
				>
					{image_url && (
						<div className="relative mr-4">
							<img
								className={playerAvatarImgClassName}
								src={`${image_url}?w=75&h=75`}
								alt={`${team_name} logo`}
								style={{
									width: '75px',
									height: '75px',
									minWidth: '75px',
									minHeight: '75px'
								}}
							/>
						</div>
					)}
					<div>
						<div className="text-2xl font-bold">{team_name}</div>
						<div>
							<div className="text-lg text-gray-500 dark:text-dark-text-secondary">
								{league_name} • {platform} • {scoring}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FixedRosterBanner;
